import PropTypes from 'prop-types';
import { ControlledDatePicker } from '@@viewCommonComponents/controlled';
import { Icon } from '@fasstech/middle-design-system';
import useMembersInformation from '../hooks/useMembersInformation';
import { CardContent } from '@@viewCommonComponents/CardContainer';

const MembersInformations = ({
  customer,
  onModifyEffectDate,
  getMiddleText,
  getMiddleBoolean,
  regimeObligatoire,
  jobs,
  professionalSituations,
  socioProfessionalCategories,
  activities
}) => {
  const { customerCardOptions, form } = useMembersInformation({
    regimeObligatoire,
    jobs,
    professionalSituations,
    socioProfessionalCategories,
    activities,
    customer,
    getMiddleText,
    getMiddleBoolean
  });

  return (
    <div className={'flex flex-col md:flex-row! justify-between items-start gap-8'}>
      <div className="flex">
        <div id="datePicker" className="w-[170px] mb-6 mt-4">
          <ControlledDatePicker
            name="offer.effectDate"
            label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
            form={form}
            disabled={true}
            onClick={onModifyEffectDate}
            data-testid="PROCESSDEVENTE_DATE_EFFET"
            containerClassName={'md:w-[90%]!'}
          />
        </div>
      </div>

      <div className={'w-full'}>
        {customer && (
          <div className="border border-[#CBCCCD] rounded-md w-full min-w-[30%] h-fit">
            <div className="flex flex-col items-center p-4">
              <Icon name={'informations_adherent'} size={50} />
              <span className="text-xl font-bold">{getMiddleText('CLIENT_TITLE')}</span>
              <CardContent data={customerCardOptions} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

MembersInformations.propTypes = {
  customer: PropTypes.object,
  onModifyEffectDate: PropTypes.func,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  regimeObligatoire: PropTypes.object
};

export default MembersInformations;
